<template>
  <div class="p">
      <div class="p-head">
        <i class="head-icon"/>
        <p class="head-title">题目作答情况分布</p>
      </div>
    <!-- 人数分布柱折图 -->
    <div
      id="myecharts" ref="myecharts" @click="jumpDetil($event)"></div>
  </div>
</template>

<script>
// import Empty from '@/views/pt/components/empty.vue';

export default {
  name: 'CourseEcharts',
  components: {
  },
  props: {
    topicList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      questionId: '',
    };
  },
  mounted() {
    this.openEcharts();
  },
  watch: {
    topicList() {
      this.openEcharts();
    },
  },
  methods: {
    jumpDetil() { // 柱状图提示框内跳转
      this.$emit('changeActiveName', this.questionId);
    },
    openEcharts() { // 柱状图和折线图
      const chartDom = document.getElementById('myecharts');
      const myChart = this.$echarts.init(chartDom);
      const option = {
        grid: {
          left: '5%',
        },
        tooltip: {
          trigger: 'axis',
          // enterable: true, // 鼠标可以进入
          // triggerOn: 'click', // 可点击
          // axisPointer: {
          //   type: 'cross',
          //   crossStyle: {
          //     color: '#1890FF',
          //   },
          // },
          formatter: (params) => {
            // console.log(params, 'params');
            // const color = 'black';// 图例颜色
            const index = params[0].dataIndex;
            // console.log(this.topicList[index].question_id);
            this.questionId = this.topicList[index].question_id;
            const htmlStr = '';
            return htmlStr;
          },
        },
        xAxis: [
          {
            type: 'category',
            name: '序号',
            nameTextStyle: {
              align: 'right',
              fontSize: 16,
              padding: [0, -15, 0, 0],
            },
            data: this.topicList
            && this.topicList.map((item) => `试题${item.index}`),
            axisPointer: {
              type: 'shadow',
              textStyle: {
                color: '#1890FF',
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '正答率',
            nameTextStyle: {
              align: 'right',
              padding: [0, 0, 15, 0],
            },
            splitLine: { // 网格线
              lineStyle: {
                type: 'dashed', // 设置网格线类型 dotted：虚线 solid:实线
                width: 1,
              },
              show: true, // 隐藏或显示
            },
            min: 0,
            max: 100,
            interval: 10,
            axisLabel: {
              formatter: '{value}%',
            },
          },
        ],
        series: [
          {
            name: '学习人数',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              normal: {
                color: '#1890FF',
                label: {
                  formatter: '{c}%',
                  show: true, // 开启显示
                  position: 'top', // 在上方显示
                  textStyle: { // 数值样式
                    color: '#1890FF',
                    fontSize: 16,
                  },
                },
              },
            },
            data: this.topicList
            && this.topicList.map((item) => item.right_rate.toFixed()),
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.p {
  &-head{
    padding-left:19px;
    position: relative;
    .head-icon{
      display: block;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
    }
    .head-title{
      position: absolute;
      top:5px;
      left:34px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
    .head-operate{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding:25px;
      .el-button {
        border-radius: 0 4px 4px 0;
      }
      .el-input {
        width: 243px;
        vertical-align: bottom;
        /deep/ .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
    }
  }
  #myecharts {
    // width: 90vw;
    height: 400px;
  }
}
</style>
